import { createContext, PropsWithChildren, useState } from 'react'

export type ErrorCode = 'mobile-access' | 'account-access' | 'unauthorized-email' | 'unexpected-error' | undefined

export const AppErrorContext = createContext<{ error: ErrorCode; setError: (error) => void }>({
  error: undefined,
  setError: () => {},
})

export const AppErrorContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [error, setError] = useState<ErrorCode>()
  return <AppErrorContext.Provider value={{ setError, error }}>{children}</AppErrorContext.Provider>
}
